import { cloneElement, type CSSProperties, type ReactElement, type ReactNode } from 'react';

/** Style for a header cell of a sized column (undefined = fit content). */
export function columnWidthStyle(width: number | undefined): CSSProperties | undefined {
  return width ? { width, minWidth: width, maxWidth: width } : undefined;
}

/**
 * A body cell held to its column's width. A table cell can't be narrower than
 * its content, so the content goes in a box of that width that clips — which
 * is what lets a column be dragged narrower than its longest value.
 * `padding` is the cell's own horizontal padding (both sides).
 */
export function sizedCell(
  cell: ReactElement<{ style?: CSSProperties; children?: ReactNode }>,
  width: number | undefined,
  padding: number,
): ReactElement {
  if (!width) return cell;
  return cloneElement(cell, {
    style: { ...cell.props.style, ...columnWidthStyle(width) },
    children: (
      <div style={{ width: Math.max(0, width - padding), overflow: 'hidden' }}>
        {cell.props.children}
      </div>
    ),
  });
}
